import { API, Auth } from "aws-amplify";
import { getUserOrgs } from "../apis/UserApis";
import React from "react";
import ReactDOM from 'react-dom';
import { ClearSearchButton } from 'react-bootstrap-table';

export class MySearchField extends React.Component {
  // It's necessary to implement getValue
  getValue() {
    return ReactDOM.findDOMNode(this).value;
  }

  // It's necessary to implement setValue
  setValue(value) {
    ReactDOM.findDOMNode(this).value = value;
  }

  render() {
    return (
      <input
        className={ `form-control` }
        style={{padding:'17px'}}
        type='text'
        defaultValue={ this.props.defaultValue }
        placeholder={ this.props.placeholder }
        onKeyUp={ this.props.searchData }
      />
    );
  }
}

function handleClearButtonClick(onClick){
  // Custom your onClick event here,
  // it's not necessary to implement this function if you have no any process before onClick
  console.log('This is my custom function for ClearSearchButton click event');
  onClick();
}

export function createCustomClearButton(onClick) {
  return (
    <ClearSearchButton
      btnText='x'
      className='my-custom-class'
      onClick={ e => handleClearButtonClick(onClick) }/>
  );
}

export async function getUsers(restaurantId) {
  try {
    let path = "";
    if (restaurantId === "global") {
      path = "/list/usersTable";
    } else {
      path = "/list/usersTable?restaurantId=" + restaurantId;
    }
    return await API.get("list", path, {})
      .then(data => {
        return data;
      })
      .catch(err => {
        return err;
      });
  } catch (e) {
    console.log(e);
  }
}

export async function getRestaurants() {
  try {
    const restaurantsData = await API.get("list", "/list/restaurant", {});
    return restaurantsData;
  } catch (e) {
    console.log(e);
  }
}

export async function userLogedinOrNot() {
  return await Auth.currentAuthenticatedUser()
    .then(user => {
      return user;
    })
    .catch(() => console.log("Not signed in"));
}

export async function signUp(username, password) {
  try {
    return await Auth.signUp({
      username: username,
      password: password
    })
      .then(data => {
        return data;
      })
      .catch(err => {
        return err;
      });
  } catch (e) {
    console.log(e);
  }
}

export async function addUser(
  clubId,
  userId,
  firstName,
  lastName,
  phoneNumber,
  profile,
  clubName,
  email
) {
  try {
    return await API.post("users", "/api/users", {
      body: {
        firstName: firstName,
        lastName: lastName,
        userId: userId,
        phone_number: phoneNumber,
        profile: profile,
        clubName: clubName,
        clubId: clubId,
        email: email
      }
    })
      .then(data => {
        return data;
      })
      .catch(err => {
        return err;
      });
  } catch (e) {
    console.log(e);
  }
}

export async function getUser(userId) {
  try {
    console.log(userId);
    return await API.get("get", "/general/get/users/" + userId, {});
  } catch (e) {
    console.log("Error");
    console.log(e.message);
    console.log(e);
  }
}

export async function getRestaurantInfo(restaurantId) {
  try {
    return await API.get("get", "/api/get/restaurant/" + restaurantId, {})
      .then(data => {
        return data;
      })
      .catch(err => {
        return err;
      });
  } catch (e) {
    console.log(e);
  }
}

//Validating email
export function  validateEmail(email){
  let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
  if(!emailValid) {
    alert("Please enter valid email id!");
    return false;
  }
  return true;
}

export function validatePhone(phone) {
  let firstCharacter = phone[0];
  let phoneNumber = phone.replace(/[^0-9]/g, "");
  phoneNumber = firstCharacter === "+"?"+"+phoneNumber:"+1"+phoneNumber;
  if((phoneNumber.substring(0,2) === "+1" && phoneNumber.length !== 12) || (phoneNumber.substring(0,2) === "+9" && phoneNumber.length !== 13)) {
    alert("Please enter valid phone number!");
    return "false";
  }
  return phoneNumber;
}


export async function getLoggedUserData() {
  const userData = await Auth.currentAuthenticatedUser({
    bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
  });
  console.log(userData);
  const userInfo = await getUser(userData.username);
  // console.log(userInfo);
  if (userInfo["userProfile"] !== "A" && userInfo["userProfile"] !== "S") {
    alert("You don't have permissions");
    // this.props.history.push("/login");
    return false;
  }
  if (userInfo["userProfile"] === "S") {
    localStorage.setItem("orgName", "Global");
    localStorage.setItem("orgId", "global");
  } else {
    let user = await getUserOrgs(userData.username);
    const userOrgs = user["data"];
    // console.log(userOrgs);
    localStorage.setItem("orgName", userOrgs[0]["orgName"]);
    localStorage.setItem("orgId", userOrgs[0]["id"]);
  }
  localStorage.setItem("login", true);
  localStorage.setItem(
    "userName",
    userInfo["firstName"] + " " + userInfo["lastName"]
  );
  localStorage.setItem("userProfile", userInfo["userProfile"]);
  localStorage.setItem("email", userInfo["email"]);
  localStorage.setItem("userId", userInfo["id"]);
  localStorage.setItem("restaurantId", userInfo["restaurantId"]);
  localStorage.setItem("UserDetails", JSON.stringify(userInfo));
  if (userInfo["picture"] && userInfo["picture"] !== "NULL") {
    this.setState({
      profile_pic: await Storage.get(userInfo["picture"])
    });
  }
  localStorage.setItem("profile_pic", "../../assets/img/avatars/user.png");
  return true;
}

export async function filter_searched_data(search_text, allData, searched_columns){
  let filter_data = [];
  await searched_columns.forEach(column => {
    filter_data.push(...allData.filter((script) => script[column]?.toString().toLowerCase().indexOf(search_text.toLowerCase()) > -1));
  });
  filter_data = filter_data.filter((v,i,a)=>a.findIndex(v2=>(v2.id===v.id))===i)
  return filter_data
}